import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const MainInfoPanelStyled = styled.section`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 3rem;
  margin-bottom: 4rem;
`;
